module.exports = __webpack_public_path__ + "img/home-insurance-icon.4fff7d60.svg";